import React from 'react';
import './UserView.scss';
import { UserHeader } from 'components/Headers/UserHeader/UserHeader';
import { useViewVM } from '../useViewVM';

export type UserViewProps = {
    render: React.ReactNode;
};

export const UserView: React.FC<UserViewProps> = ({ render }) => {
    useViewVM({ render });

    return (
        <>
            <UserHeader />
            <div className="renderer user">{render}</div>
        </>
    );
};
